module.exports = __webpack_public_path__ + "img/bg_avatar_female_51.f0d0ae35.png";